/* Baoba - Sticky ATC: n'afficher que le bouton 'Ajouter au panier'.
   Masque le sélecteur de variante (qui affiche le prix) et la quantité,
   et garde la variante du sticky synchronisée avec celle choisie sur la page. */
(function () {
  // 1) Masquage (injecté en CSS pour surcharger le style inline du sticky)
  var css =
    '#md-sticky-atc .product-content{display:none !important;}' +
    '#md-sticky-atc .product-form .select,' +
    '#md-sticky-atc .quantity-input-wrapper .select,' +
    '#md-sticky-atc .product-form .quantity,' +
    '#md-sticky-atc quantity-input.quantity{display:none !important;}' +
    '#md-sticky-atc .product-form .quantity-input-wrapper{justify-content:center;}' +
    '#md-sticky-atc .product-form button[name=add]{flex-grow:1;width:100%;margin:0;}';
  var style = document.createElement('style');
  style.setAttribute('data-baoba-sticky', '1');
  style.textContent = css;
  (document.head || document.documentElement).appendChild(style);

  // 2) Synchronisation de la variante du sticky avec la variante choisie
  function stickySelect() {
    var s = document.getElementById('md-sticky-atc');
    return s ? s.querySelector('select[name=id]') : null;
  }
  function currentVariantId() {
    var v = new URLSearchParams(location.search).get('variant');
    if (v) return v;
    var info = document.querySelector('product-info');
    if (info) {
      var inp = info.querySelector('input[name=id]');
      if (inp && inp.value) return inp.value;
    }
    return null;
  }
  function syncSticky() {
    var sel = stickySelect();
    if (!sel) return;
    var id = currentVariantId();
    if (!id) return;
    id = String(id);
    if (sel.value === id) return;
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].value === id) { sel.value = id; break; }
    }
  }
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(syncSticky, 60); }
  document.addEventListener('change', schedule, true);
  document.addEventListener('click', schedule, true);
  window.addEventListener('popstate', schedule);
  [300, 800, 1500].forEach(function (d) { setTimeout(syncSticky, d); });
})();
